//---------------Auto Copyright----------------

let currentDate = document.querySelector(".date_select");
let laDate = new Date();
currentDate.innerHTML = "© "+laDate.getFullYear();

//--------------Burger Menu--------------------

"use strict";
const menuIcon = document.querySelector(".burgerMenu");
menuIcon.addEventListener('click', toggleMenu);

function toggleMenu () {
   menuIcon.classList.toggle('menu-expanded');
};

//-------------Slider------------------------

const btnPrev = document.querySelector(".slider__btn--prev");
const btnNext = document.querySelector(".slider__btn--next");

btnNext.addEventListener("click", next);
btnPrev.addEventListener("click", prev);

function next(){
    let elShow = document.querySelector(".slider__el--show"),
        elNext =elShow.nextElementSibling;
    elShow.classList.remove("slider__el--show");
    if (elNext){
    elNext.classList.add("slider__el--show");
    } else {
        let elFirst = elShow.parentNode.firstElementChild;
        elFirst.classList.add("slider__el--show")
    }
};

function prev(){
    let elShow = document.querySelector(".slider__el--show"),
        elPrev =elShow.previousElementSibling;

    elShow.classList.remove("slider__el--show");
    if (elPrev){
        elPrev.classList.add("slider__el--show");
    } else {
        let elLast = elShow.parentNode.lastElementChild;
        elLast.classList.add("slider__el--show")
    }
}

const slider = document.querySelector(".slider"),
    hammerSlider = new Hammer(slider);

hammerSlider.on("swipeleft", next);
hammerSlider.on("swiperight", prev);

//--------------Animation sorte ---------------------

var navEl = document.querySelectorAll(".header a");
for(var i=0; i < navEl.length; i++){
    navEl[i].addEventListener("click", function(e){

        e.preventDefault();
        
        var currentlink = this.href

        document.body.classList.add("out");
        document.body.addEventListener("animationend", function(){
            window.location = currentlink;
        });

    });
}